import store from '../../../store/store';
import { asyncHandler } from '../async-handler';
import { RequestInfo } from '../../../interfaces/RequestInfo';
import { mcpCredentialsUrl, resolveMcpAuth } from './mcp-auth';
import { submitLogToBugsnag } from '../log';
import { buildUpdateMcpBody } from './mcp-credentials-payload';

/**
 * `credentials` may be left undefined (or empty) for an update that changes no
 * credential field, e.g. switching a connection on or off: the request then
 * omits the key and central-api keeps what it has stored.
 */
export default async function update_mcp_api_call(
  connectionId: number,
  credentials: any,
  isActive: boolean,
  oauthCode?: string,
  shouldShowMsg: boolean = true
) {
  try {
    const shopSlug = store.getState().user?.company?.shop_slug;
    const auth = resolveMcpAuth();

    const requestInfo: RequestInfo = {
      url: `${mcpCredentialsUrl(auth, shopSlug)}/${connectionId}`,
      method: 'PATCH',
      body: JSON.stringify(
        buildUpdateMcpBody(credentials, isActive, oauthCode)
      ),
      headers: {
        Accept: 'application/json',
        'Content-type': 'application/json',
        Authorization: auth.authorization,
      },
    };

    const actionType = 'UPDATE_MCP_CONNECTION';
    const customMsg = isActive
      ? 'Integration Connection Successful.'
      : `Integration Connection Deactivated.`;

    const res: any = await asyncHandler(
      requestInfo,
      actionType,
      customMsg,
      shouldShowMsg,
      false,
      // shouldShowErrorMsg: surface the backend's error body (e.g. Shopify's
      // 400 "Connection failed…" when the live Admin API check rejects the
      // token) — 422 validation errors were already surfaced, but plain
      // success:false responses were silently swallowed before.
      true,
      false,
      ['You have reached the maximum number of credentials for the free tier']
    );

    const response = res.data;

    if (res.actionType === actionType) {
      return response;
    } else {
      return {};
    }
  } catch (exception) {
    console.log('Error during authentication request');
    submitLogToBugsnag('error', `${exception}`);
    return false;
  }
}
